<main class="container irembogov-service-templates">
  <div class="row">
    <div class="col-md-12">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4>Service Templates</h4>

        <!-- Admin Actions -->
        <div *ngIf="canManageTemplates()" class="d-flex gap-2">
          <button
            type="button"
            class="btn btn-outline-primary"
            routerLink="/services/templates/convert-existing">
            <i class="fas fa-exchange-alt me-2"></i>
            Convert Existing Service
          </button>
          <button
            type="button"
            class="btn btn-primary"
            routerLink="/services/templates/create">
            <i class="fas fa-plus me-2"></i>
            Add New
          </button>
        </div>
      </div>

      <!-- Templates Table Section -->
      <div class="irembogov-service-templates-table">
        <irembogov-irembo-section-message
          type="info"
          *ngIf="!isLoading && templates.length < 1"
          class="w-80 mx-auto mt-5 d-block"
          title=""
          [message]="
            canManageTemplates()
              ? 'No templates found. Get started by creating your first service template.'
              : 'No published templates are available yet.'
          "
          [dismissible]="false">
        </irembogov-irembo-section-message>

        <irembogov-custom-table-wrapper
          [isSortVisible]="false"
          [loading]="isLoading"
          [paginationVisible]="true"
          [totalItems]="totalElements"
          [itemsPerPage]="pageSize"
          [currentPage]="currentPage + 1"
          (paginationChange)="onPageChange($event.pageNumber - 1)">
          <div class="extra-filters d-flex flex-row gap-3" leftHeader>
            <div class="form-group status-filter-form-group">
              <irembogov-button-group
                class="irembogov-button-group"
                [itemList]="templateStatuses"
                [selectedItem]="selectedStatus"
                (itemChange)="onStatusChange($event)">
              </irembogov-button-group>
            </div>
          </div>
          <div class="extra-filters d-flex flex-row gap-3" rightHeader>
            <div class="form-group category-filter-form-group">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-tag"></i>
                </span>
                <select
                  class="form-select"
                  [(ngModel)]="selectedCategory"
                  (ngModelChange)="onCategoryChange($event)">
                  <option value="">All Categories</option>
                  <option
                    *ngFor="let category of filteredCategories"
                    [value]="category.id">
                    {{ category.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group search-filter-form-group">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
                <input
                  [(ngModel)]="searchTerm"
                  (ngModelChange)="onSearchChange()"
                  placeholder="Search templates by name"
                  type="text"
                  class="form-control" />
              </div>
            </div>
          </div>

          <table body aria-label="Service Templates Table" class="table">
            <thead>
              <tr>
                <th scope="col" class="text-nowrap">Template Name</th>
                <th scope="col" class="text-nowrap">Category</th>
                <th scope="col" class="text-nowrap">Status</th>
                <th scope="col" class="text-nowrap">Usage Count</th>
                <th scope="col" class="text-nowrap">Published Date</th>
                <th scope="col" class="text-nowrap">Action</th>
              </tr>
            </thead>
            <tbody class="rounded bg-white" *ngIf="!isLoading">
              <tr *ngFor="let template of templates; let index = index">
                <td class="text-wrap">
                  <strong>{{ template.name }}</strong>
                  <div class="text-muted small" *ngIf="template.description">
                    {{ template.description | slice : 0 : 50 }}
                    {{ template.description.length > 50 ? '...' : '' }}
                  </div>
                </td>
                <td class="text-wrap">
                  <span>
                    {{ categoryMap[template.categoryId] || 'Uncategorized' }}
                  </span>
                </td>
                <td class="text-nowrap">
                  <irembogov-service-template-status-badge
                    [status]="template.status">
                  </irembogov-service-template-status-badge>
                </td>
                <td class="text-nowrap">
                  <span>{{ template.usageCount || 0 }}</span>
                </td>
                <td class="text-nowrap">
                  <span *ngIf="template.publishedDate">
                    {{ template.publishedDate | date : 'MMM d, y' }}
                  </span>
                  <span *ngIf="!template.publishedDate" class="text-muted">
                    Not published
                  </span>
                </td>
                <td class="text-nowrap action-column">
                  <div class="dropdown" ngbDropdown>
                    <button
                      class="btn btn-sm btn-primary dropdown-toggle action-btn"
                      type="button"
                      [id]="'templateAction' + template.id"
                      ngbDropdownToggle
                      [attr.aria-expanded]="false">
                      Action
                    </button>
                    <div
                      class="dropdown-menu"
                      ngbDropdownMenu
                      [attr.aria-labelledby]="'templateAction' + template.id">
                      <!-- Service Manager Actions -->
                      <ng-container *ngIf="canUseTemplates()">
                        <button
                          class="dropdown-item"
                          [routerLink]="[
                            '/services/templates',
                            template.id,
                            'preview'
                          ]">
                          <i class="fas fa-eye me-2"></i>
                          View Template
                        </button>
                        <button
                          *ngIf="
                            template.status === ServiceTemplateStatus.PUBLISHED
                          "
                          class="dropdown-item text-primary"
                          [routerLink]="[
                            '/services/templates',
                            template.id,
                            'use'
                          ]">
                          <i class="fas fa-plus me-2"></i>
                          Use Template
                        </button>
                      </ng-container>

                      <!-- Admin Actions -->
                      <ng-container *ngIf="canManageTemplates()">
                        <button
                          class="dropdown-item"
                          [routerLink]="[
                            '/services/templates',
                            template.id,
                            'preview'
                          ]">
                          Preview Template
                        </button>
                        <button
                          *ngIf="
                            template.status === ServiceTemplateStatus.DRAFT
                          "
                          class="dropdown-item"
                          [routerLink]="[
                            '/services/templates',
                            template.id,
                            'edit'
                          ]">
                          Edit Template
                        </button>
                        <button
                          *ngIf="
                            template.status === ServiceTemplateStatus.DRAFT
                          "
                          class="dropdown-item"
                          (click)="
                            showPublishConfirmation(template.id, template.name)
                          ">
                          Publish Template
                        </button>
                        <button
                          *ngIf="
                            template.status === ServiceTemplateStatus.PUBLISHED
                          "
                          class="dropdown-item"
                          (click)="
                            showUnpublishConfirmation(
                              template.id,
                              template.name
                            )
                          ">
                          Unpublish Template
                        </button>
                        <div class="dropdown-divider"></div>
                        <button
                          class="dropdown-item text-danger"
                          (click)="
                            showDeleteConfirmation(template.id, template.name)
                          ">
                          Delete Template
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </irembogov-custom-table-wrapper>
      </div>
    </div>
  </div>

  <!-- Delete Confirmation Modal -->
  <irembogov-delete-template-confirmation-modal
    [show]="showDeleteModal"
    [itemName]="templateToDelete?.name || ''"
    [itemType]="'template'"
    (confirmed)="confirmDelete()"
    (cancelled)="cancelDelete()">
  </irembogov-delete-template-confirmation-modal>

  <!-- Publish Confirmation Modal -->
  <irembogov-publish-confirmation-modal
    [show]="showPublishModal"
    [templateName]="templateToPublish?.name || ''"
    (confirmed)="confirmPublish()"
    (cancelled)="cancelPublish()">
  </irembogov-publish-confirmation-modal>

  <!-- Unpublish Confirmation Modal -->
  <irembogov-unpublish-confirmation-modal
    [show]="showUnpublishModal"
    [templateName]="templateToUnpublish?.name || ''"
    (confirmed)="confirmUnpublish()"
    (cancelled)="cancelUnpublish()">
  </irembogov-unpublish-confirmation-modal>
</main>
